import { Button, Grid } from "@mui/material";

import { downloadButtons } from "../Footer/constants";
import Image from "../Image/image";

export default function DownloadApp() {
  return (
    <Grid container>
      {downloadButtons.map((button, index) => (
        <Grid item xs={6} key={button.title}>
          <Button
            type="button"
            href={button.link}
            target="_blank"
            sx={{
              "&:hover": {
                cursor: "pointer",
                transform: "scale(1.04)",
                backgroundColor: "transparent",
              },
            }}
          >
            <Image
              src={button.icon}
              width={index === 0 ? "96%" : "100%"}
              alt="store button"
              height="auto"
            />
          </Button>
        </Grid>
      ))}
    </Grid>
  );
}
